export default {"src":"/_next/static/media/CloseIcon.b23a04a7.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};